import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { APP_NAME, STATIC_CMS_ROOT } from '../../../constants';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import { getInstertitielCashbackUrl } from '../../../services/partner/utils';

import LocalizedNavLink from '../../router/LocalizedNavLink';

class MeaMerchantCardComponent extends React.Component {
    showLoginModal = () => {
        const { showModal } = this.props;

        showModal(MODAL_TYPE_LOGIN);
    };

    renderUrl = () => {
        const { mea, partner } = this.props;

        if (partner) {
            if (mea && mea.tracking) {
                return `${getInstertitielCashbackUrl(partner)}?urlSource=${encodeURIComponent(
                    mea.tracking
                )}`;
            } else {
                if (partner) {
                    return getInstertitielCashbackUrl(partner);
                }
            }
        }
    };

    renderImage = () => {
        const { mea } = this.props;

        if (mea && mea.image) {
            if (mea.image.startsWith('http')) {
                return mea.image;
            } else {
                return `${STATIC_CMS_ROOT}/fm/${mea.image}`;
            }
        }
    };

    renderMea = () => {
        const { isAuthenticated, partner, isOffline } = this.props;

        if (!isOffline) {
            if (isAuthenticated) {
                return (
                    <LocalizedNavLink
                        to={this.renderUrl()}
                        target="_blank"
                        name="merchantCard-toPartner">
                        <img
                            src={this.renderImage()}
                            alt={partner && partner.name ? partner.name : APP_NAME}
                            width="728"
                            height="90"
                        />
                    </LocalizedNavLink>
                );
            } else {
                return (
                    <img
                        src={this.renderImage()}
                        alt={partner && partner.name ? partner.name : APP_NAME}
                        className="pointer"
                        width="728"
                        height="90"
                        onClick={this.showLoginModal}
                    />
                );
            }
        } else {
            return (
                <img
                    src={this.renderImage()}
                    alt={partner && partner.name ? partner.name : APP_NAME}
                    width="728"
                    height="90"
                />
            );
        }
    };

    render() {
        const { mea } = this.props;

        if (mea && mea.id > 0) {
            return (
                <React.Fragment>
                    <div className="fm-mea hidden-mobonly">{this.renderMea()}</div>
                </React.Fragment>
            );
        }
        return null;
    }
}

MeaMerchantCardComponent.propTypes = {
    mea: PropTypes.object,
    partner: PropTypes.object,
    isOffline: PropTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.authentication.isAuthenticated
});

const mapDispatchToProps = {
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(MeaMerchantCardComponent);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/MeaMerchantCardComponent.js